

var Navigation = {
  init(){
    this.menu = $('.fnc-navMenu');
    this.bg = $('.fnc-navMenuBg');
    this.btnOpen = $('.fnc-navMenuBtn');
    this.btnClose = $('.fnc-navMenuBtnClose a');

    this.animation = false;
    this.event();

  },
  event(){
    this.btnOpen.on('click', (e)=>{
      e.preventDefault();

      if(!this.animation){
        this.showBg();
      }

    });

    this.btnClose.on('click', (e)=>{
      e.preventDefault();
      e.stopPropagation();

      if(!this.animation){
        this.hideNav();
      }

    });

    this.bg.on('click', (e)=>{

      if(!this.animation){
        this.hideNav();
      }

    });

    $(window).on('resize.slick', ()=>{
      if( window.matchMedia('(min-width: 768px)').matches ){
        this.reset();
      }
    });
  },
  hideBg(){

    TweenMax.to(this.bg , 0.5 , {
      opacity : 0, 
    　ease : "Linear" ,
      onComplete : ()=>{
        this.animation = false;
        TweenMax.set(this.bg , {display: 'none'});
        this.reset();
      }
    });
  },
  showBg(){
    this.animation = true;
    TweenMax.set(this.bg , {display: 'block'});

    TweenMax.set($('html'), {overflow: 'hidden'});


    TweenMax.to(this.bg , 0.5 , {
      opacity : 0.5, 
    　ease : "Linear" ,
      onComplete : ()=>{
        this.showNav();
      }
    });
  },
  hideNav(){
    this.animation = true;
    TweenMax.to(this.menu , 0.5 , {
      right: -200, 
    　ease : "Linear" ,
      onComplete : ()=>{
        TweenMax.set(this.menu , {display: 'none'});
        this.hideBg();
      }
    });
  },
  showNav(){
    TweenMax.set(this.menu , {display: 'block', right: -200});
    TweenMax.to(this.menu , 0.3 , {
      right: 0, 
    　ease : "Linear" ,
      onComplete : ()=>{
        this.animation = false;
      }
    });
  },
  reset(){
    this.menu.removeAttr('style');
    this.bg.removeAttr('style');
    $('html').removeAttr('style');
  },
  winCheck(){

  }
}

module.exports = Navigation;


// WEBPACK FOOTER //
// ./src/js/fncs/Navigation.js